import { useState } from "react";

import "flag-icons/css/flag-icons.min.css";

import { MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LanguageIcon from "@mui/icons-material/Language";
import _ from "lodash";

import { Black, WhiteSmoke } from "assets/colors";
import { IOption } from "model/application/components";

const styles = () => ({
  selectLanguage: {
    position: "relative",
    cursor: "pointer",

    paddingTop: 2,
    paddingLeft: 2,
    width: 28,
    height: 28,
    borderRadius: 14,
    "&:hover": {
      background: WhiteSmoke,
    },
  },
  iconButton: {
    color: "#124E5D",
  },
  dropDown: {
    position: "absolute",
    right: "5px",
    boxShadow: "4px 6px 20px 0px #c9c8c7",
  },
});

const useStyles = makeStyles(styles as any);

export interface IInputSelectLanguage {
  options: IOption<string>[];
  value?: string;
  onChange: (optSelected: string) => void;
}

export const InputSelectLanguage = ({
  value,
  onChange,
  options,
}: IInputSelectLanguage) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleChange = (value: string) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className={classes.selectLanguage}>
      <LanguageIcon
        onClick={() => setIsOpen(!isOpen)}
        className={classes.iconButton}
      />
      <div role="menu-items" className={classes.dropDown}>
        {isOpen &&
          _.map(_.compact(options), (option: any) => {
            const { key, label, index } = option;
            return (
              <MenuItem
                key={index}
                onClick={() => handleChange(key)}
                value={key}
                style={{
                  backgroundColor: key === value ? "#ededeb" : "white",
                }}
              >
                <span
                  className={`fi fi-${label.toLowerCase()}`}
                  style={{
                    height: "13px",
                    verticalAlign: "middle",
                  }}
                ></span>

                <span
                  style={{
                    marginLeft: 5,
                    fontSize: "14px",
                    verticalAlign: "middle",
                    color: Black,
                  }}
                >
                  {option.value}
                </span>
              </MenuItem>
            );
          })}
      </div>
    </div>
  );
};

export default InputSelectLanguage;
